function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-320 -211)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#ic-instagram_svg__ic-instagram_svg__a)",
  xlinkHref: "#ic-instagram_svg__ic-instagram_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#ic-instagram_svg__ic-instagram_svg__b"
})), React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M18.4 7.6a.4.4 0 01-.4.4h-1.6a.4.4 0 01-.4-.4V6c0-.22.18-.4.4-.4H18c.22 0 .4.18.4.4v1.6zM6 18.4a.4.4 0 01-.4-.4v-6.8h1.672a4.376 4.376 0 00-.072.8 4.8 4.8 0 109.6 0c0-.272-.032-.544-.072-.8H18.4V18a.4.4 0 01-.4.4H6zm6-9.6a3.2 3.2 0 110 6.4 3.2 3.2 0 010-6.4zM18.4 4H5.6C4.712 4 4 4.712 4 5.6v12.8A1.6 1.6 0 005.6 20h12.8a1.6 1.6 0 001.6-1.6V5.6A1.6 1.6 0 0018.4 4z"
}));

var SvgIcInstagram = function SvgIcInstagram(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMjAgLTIxMSkiPgogICAgICAgICAgICA8dXNlIGZpbGw9IiMwMDAiIGZpbHRlcj0idXJsKCNhKSIgeGxpbms6aHJlZj0iI2IiLz4KICAgICAgICAgICAgPHVzZSBmaWxsPSIjRkZGIiB4bGluazpocmVmPSIjYiIvPgogICAgICAgIDwvZz4KICAgICAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzEwMkU4RSIgZD0iTTE4LjQgNy42YS40LjQgMCAwIDEtLjQuNGgtMS42YS40LjQgMCAwIDEtLjQtLjRWNmMwLS4yMi4xOC0uNC40LS40SDE4Yy4yMiAwIC40LjE4LjQuNHYxLjZ6TTYgMTguNGEuNC40IDAgMCAxLS40LS40di02LjhoMS42NzJhNC4zNzYgNC4zNzYgMCAwIDAtLjA3Mi44IDQuOCA0LjggMCAxIDAgOS42IDBjMC0uMjcyLS4wMzItLjU0NC0uMDcyLS44SDE4LjRWMThhLjQuNCAwIDAgMS0uNC40SDZ6bTYtOS42YTMuMiAzLjIgMCAxIDEgMCA2LjQgMy4yIDMuMiAwIDAgMSAwLTYuNHpNMTguNCA0SDUuNkM0LjcxMiA0IDQgNC43MTIgNCA1LjZ2MTIuOEExLjYgMS42IDAgMCAwIDUuNiAyMGgxMi44YTEuNiAxLjYgMCAwIDAgMS42LTEuNlY1LjZBMS42IDEuNiAwIDAgMCAxOC40IDR6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIcInstagram as ReactComponent };